import React, { useContext, useRef } from 'react'
import styles from './ModalSecondView.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ChangeModal from './changeModal'
import { InvoiceModalValues } from './ModalFirstView'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import ModalButton from 'spa/member/components/ModalButton'
import InvoiceRequestedImg from '../../../../../assets/images/invoice/invoice_requested.svg'
import MemberTechCompanyName  from '../../../../spa/member/components/MemberTechCompanyName'
import { useWindowWidth } from "../../../../spa/hooks/useWindowWidth";
import { breakpoints } from "../../../../spa/config/styled";

interface ChangeModalProps extends ChangeModal {
  name: string,
  companyNameFlag: boolean
}

const ModalSecondView: React.FC<ChangeModalProps> = (props) => {
  const context = useContext(InvoiceModalValues)
  const inputRef = useRef(null)
  const windowWidth = useWindowWidth()
  const isSp = windowWidth < breakpoints.sm

  const handleStartClick = () => {
    inputRef.current.focus()
  }

  const checkCharAndType = (event: string) => {
    const noNumeric = /[^0-9]/.test(event)
    const valid = event.length === 13 && !noNumeric
    context.setIsValid(valid)
    context.setGoNextBtn(valid)
  }

  const setNumber = ( event: string ) => {
    context.setInvoiceNumber(event)
    checkCharAndType(event)
  }

  const closeModal = () => {
    props.changeModal('')
    context.setErrors([])
    context.setIsValid(true)
    context.setGoNextBtn(false)
    context.setInvoiceNumber('')
  }

  //TODO: 入力エラー、APIエラーのレスポンスが決まり次第値を調整
  const errorsValue = {
    not_found: {
      title: '入力内容をご確認ください',
      description: '登録内容の確認が取れませんでした。国税庁に届け出ている情報を確認し、もう一度登録をしなおしてください。'
    },
    api_error: {
      title: 'しばらく時間をおいてお試しください',
      description: 'インボイス登録番号の検証ができませんでした。しばらく時間をおいてからもう一度お試しください。'
    }
  }

  const errorType = context.errors[0] as keyof typeof errorsValue
  const errorTitle = errorsValue[errorType]?.title
  const errorDescription = errorsValue[errorType]?.description
  const displayNameType = props.companyNameFlag ? '法人名' : '氏名'

  const errorBoX = () => {
    return (
      <div className={styles.errorBox}>
        <div className={styles.errorTitle}><p>{ errorTitle }</p></div>
        <div className={styles.errorDescription}><p>{ errorDescription }</p></div>
      </div>
    )
  }

  const validateBox = () => {
    return (
      <div className={styles.validateBox}>
        <div className={styles.validateIcon}><FontAwesomeIcon icon={faXmark} color='#e03100'/></div>
        <div className={`${styles.validateDescription} invoice-validate-description`}><p>T＋13桁の半角数字を入力してください</p></div>
      </div>
    )
  }

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modalContainer} js-modal-container`}>
        <div className={styles.sectionTitle}><p>インボイス登録番号を{isSp ? <br /> : ''}お聞かせください。</p></div>
        <div className={styles.sectionDivider}></div>
        {context.errors.some(error => ['not_found', 'api_error'].includes(error)) && errorBoX()}
        <div className={styles.sectionText}>
          <div className={styles.text}>
            <p>入力いただいた方には、インボイス登録番号を記載したお支払内容をお渡しします。</p>
          </div>
        </div>
        <div className={styles.sectionInvoiceDescription}>
          <p className={styles.text}><MemberTechCompanyName />に登録されている{displayNameType}が適格請求書発行事業者の氏名又は名称と同一かご確認ください。<MemberTechCompanyName />に登録されている{displayNameType}の変更が難しい場合は<a className={styles.inquiryText} href='/inquiry' target='_blank'>お問い合わせ</a>ください。</p>
          <img className={styles.sectionInvoiceImg} alt='国税庁へ届け出た申請書類の見本' src={InvoiceRequestedImg} />
          <p className={styles.grayImgDescription}>国税庁へ届け出た申請書類</p>
        </div>
        <div className={styles.sectionNameDescription}>
          <p>適格請求書発行事業者 氏名又は名称（<MemberTechCompanyName />に登録されている{displayNameType}を表示しています）</p>
        </div>
        <div className={styles.sectionProfile}>
          <p className={styles.currentProfileName}>{props.name}</p>
          <a className={styles.inputProfileLink} href='/profile_sheet/basic_profile'><MemberTechCompanyName />に登録されている{displayNameType}を編集</a>
        </div>
        <div className={styles.sectionContents}>
          <label htmlFor='input-number' className={styles.contentTitle}>インボイス登録番号</label>
          <div className={`${styles.contentItem} ${!context.isValid? styles.inputError : ''}`}>
            <span className={styles.tStart} onClick={handleStartClick}>T</span>
            <input
              type='text'
              id='input-number'
              ref={inputRef}
              placeholder='0000000000000'
              value={context.invoiceNumber || ''}
              onChange={event => setNumber(event.target.value)}
              className={`${styles.inputNumber} input-invoice-number`}
              required
              pattern="\d{13}"
            >
            </input>
          </div>
          { !context.isValid && validateBox() }
          <div className={styles.contentDescription}>※インボイス登録番号は「T＋法人番号」、それ以外の事業者は「T＋新たな13桁の数字の固有番号」です。<br/>
            ※13桁の半角数字でご記入ください。<br/>
            <span>※必ずご自身のインボイス登録番号をご記入ください。</span></div>
        </div>
        <div className={styles.sectionBtn}>
          <ModalButton buttonType='BACK' onClick={() => closeModal()}>キャンセル</ModalButton>
          <ModalButton buttonType={context.goNextBtn ? 'NEXT' : 'DISABLED'} onClick={() => props.changeModal('thirdModal')} className='second-modal-go-next-btn' disabled={!context.goNextBtn}>確認する</ModalButton>
        </div>
      </div>
    </div>
  )
}

export { ModalSecondView }
